import { Container } from "@chakra-ui/react";
import { motion } from "framer-motion";

const pageMotion = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.2 } },
  exit: { opacity: 0, y: 10, transition: { duration: 0.1 } },
};

function AnimatedPageWrapper({ children }) {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageMotion}
    >
      <Container maxW="100%" paddingBlock="5" minW={380} height={"100%"}>
        {children}
      </Container>
    </motion.div>
  );
}

export default AnimatedPageWrapper;
